import { ReactNode } from 'react'

import {
  GridRow,
  GridTable,
  GridTable2,
  StyledListItem,
  StyledList,
  StyledListInGridRow,
  ZenkakuSpace,
} from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const pvItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（個人情報の収集と管理）</h3>
        <p>
          トライアルグループでは、お客様等にサービスをご利用いただくために、その利用目的をご確認いただいた上で、お客様等の個人情報を登録いただいております。お客様等からご購入やお問合せ等の手続きの中で収集させていただいた個人情報は、不正アクセスや紛失、改ざん及び漏洩等が起きぬよう、厳重に管理いたします。具体的には次のような安全管理措置を講じています。
        </p>
        <StyledList liWidth="960" marginLeft="1.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            個人情報の取り扱いに関する責任者をトライアルグループ各社に設置する
          </StyledListItem>
          <StyledListItem listType="article">
            個人情報を取り扱う従業者及び当該従業者が取り扱う個人情報の範囲を明確化し、個人情報保護法等や個人情報の取り扱いに関する社内規程に違反している事実または兆候を把握した場合の責任者への報告連絡体制を整備する
          </StyledListItem>
          <StyledListItem listType="article">
            個人情報の取り扱いに関する留意事項について、従業者に定期的な教育を実施する
          </StyledListItem>
          <StyledListItem listType="article">
            個人情報を取り扱う区域において、権限を有しない者による個人情報の閲覧を防止する措置を実施する
          </StyledListItem>
          <StyledListItem listType="article">
            アクセス制御を実施して、担当者及び取り扱う個人情報の範囲を限定する
          </StyledListItem>
        </StyledList>
        <p>
          トライアルグループが収集する個人情報は、各種お問合せ、手続き時又は各種証明資料・公的資料をご提出いただいた際にお客様等からご提供いただいた特定の個人を識別できるもの（お名前、ご住所、電話番号、FAX番号、Eメールアドレス等）をその内容とします。また、その情報のみでは特定個人を識別できない場合でも、他の情報と容易に照合することができ、結果的に特定個人を識別できるものも個人情報に含まれるものとします。
          <br />
          ウェブサイト等では不正アクセス、漏えい、改ざん、破壊などからお客様等の個人情報を守るために十分な安全対策を講じていますが、お客様等のパソコンからウェブサイト等に信号が届くまでの過程につきましては、この対策が及びません。お客様等ご自身で安全管理をしていただきますよう、お願いいたします。
        </p>
      </>
    ),
    id: 'privacy1',
  },
  {
    children: (
      <>
        <h3>第2条（利用目的）</h3>
        <p>
          トライアルグループが管理するお客様等の個人情報は、お客様等の事前の同意なしに、次の利用目的を超えて利用することはございません。
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            商品・サービス等に関するお取引内容の確認と履行
          </StyledListItem>
          <StyledListItem listType="article">
            ご注文いただいた商品、お預かりした荷物等の配送手続
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルプリペイドカード会員入会審査
          </StyledListItem>
          <StyledListItem listType="article">
            商品・サービス等のご予約状況の確認、キャンセル等の対応
          </StyledListItem>
          <StyledListItem listType="article">
            商品・サービス等に関するアフターサービス
          </StyledListItem>
          <StyledListItem listType="article">
            お買上ポイントの管理、ご利用状況の管理
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループ又は第三者の商品・サービス等に関するイベント、キャンペーン、特典、優待・割引等の企画立案の検討・実施
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループ又は第三者の商品・サービス等に関するイベント、キャンペーン、特典、優待等に関する商品の発送
          </StyledListItem>
          <StyledListItem listType="article">
            お問合せ又はご意見に対する内容確認及びカスタマーサポートの提供
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループ又は第三者の商品・サービス等に関する広告その他のマーケティング活動※、ご案内資料・メールマガジン・ダイレクトメールの送付・配信
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループ又は第三者の商品・サービス等に関するアンケートの実施
          </StyledListItem>
          <StyledListItem listType="article">
            商品・サービス等の新規開発及び改善、研究開発
          </StyledListItem>
          <StyledListItem listType="article">
            各種採用イベントの実施、採用選考、従業員の雇用管理
          </StyledListItem>
          <StyledListItem listType="article">
            施設の設備及び機器の保全管理
          </StyledListItem>
          <StyledListItem listType="article">
            代金決済及び債権管理
          </StyledListItem>
          <StyledListItem listType="article">
            市場調査、売り場状況把握、顧客動向分析、商品・サービス等の利用状況分析、その他経営上必要な調査・分析、及びそのためのデータ作成（各種統計情報の作成を含む）
          </StyledListItem>
          <StyledListItem listType="article">
            防犯対策及び安全対策、不正行為の検知及びその対応
          </StyledListItem>
          <StyledListItem listType="article">
            別途お客様等に明示し又は公表した利用目的のため
          </StyledListItem>
          <StyledListItem listType="article">
            会社法等にもとづく株主様の管理及びご案内
          </StyledListItem>
          <StyledListItem listType="article">
            上記に関するお知らせ、その他緊急時のご連絡
          </StyledListItem>
          <StyledListItem listType="article">上記に付随する目的</StyledListItem>
        </StyledList>
        <p>
          ※ トライアルグループは、（1０）のマーケティング活動の一環として、Google・LINEその他の広告関連事業者（以下「広告関連事業者」という。）が保有するお客様等を含むユーザーのリスト（第三者提供につき広告関連事業者があらかじめ同意を取得しているユーザーのリストに限ります。）とトライアルグループが保有するお客様等のメールアドレス・電話番号・cookieその他ユーザーの特定に必要な情報を紐付けて、一定の条件を満たすユーザー（トライアルグループのサービス及び広告関連事業者が提供するサービスのユーザーを含みます。）にトライアルグループ又は第三者のサービスの提案・情報提供・広告配信（以下「提案等」といいます。）を行う場合があります。
        </p>
        <p>
          また、トライアルグループは、（1０）のマーケティング活動の一環として、広告関連事業者から、cookie・位置情報・広告識別子等の個人関連情報を取得し、当該個人関連情報に、トライアルグループが既に保有しているお客様等の個人情報を紐づけて、お客様等に対して提案等を行う場合があります。トライアルグループは、当該紐づけを実施する場合、対象となるお客様等からあらかじめご同意頂いた上で実施いたします。
        </p>
      </>
    ),
    id: 'privacy2',
  },
  {
    children: (
      <>
        <h3>第3条（個人情報の共同利用）</h3>
        <p>
          トライアルグループ及び株式会社SU-PAYは、お客様等の保有する個人情報を共同利用させていただく場合には、法令で定める必要事項をあらかじめご通知又は公表させていただいたうえで実施いたします。
          <br />
          ※トライアルグループおよび株式会社SU-PAY間における個人情報の共同利用については<LinkText path="/legal/privacy-policy/joint-utilization" text="こちら" />です。
        </p>
      </>
    ),
    id: 'privacy3',
  },
  {
    children: (
      <>
        <h3>第4条（第三者への提供）</h3>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループは、利用目的の達成に必要な範囲内において、取得した個人情報の取り扱いの全部又は一部を第三者に委託する場合がございます。その場合には、個人情報の保護に係る契約等の必要な契約を締結し、当該第三者への必要かつ適切な監督を実施いたします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、第２条に定める利用目的のために、あらかじめお客様等にご同意頂いた上で、お客様等の個人情報及び個人関連情報を第三者に提供する場合がございます。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、本条各号に定める場合及び共同利用の場合を除き、収集した個人情報を第三者へ提供しません。但し、お客様等の同意を得た場合又は法令で許容される場合はその限りではありません。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy4',
  },
  {
    children: (
      <>
        <h3>第5条（外国にある第三者への提供）</h3>
        <p>
          トライアルグループは、外国にある第三者に個人情報の提供を行う場合は、法令の定めに従い、同意の取得等必要な措置を講じます。
        </p>
      </>
    ),
    id: 'privacy5',
  },
  {
    children: (
      <>
        <h3>第6条（匿名加工情報の活用）</h3>
        <p>
          トライアルグループは、お客様等より提供を受けた個人情報をもとに、個人を特定できないよう加工した匿名加工情報を作成することがございます。匿名加工情報の取り扱いについては、以下の点を遵守いたします。
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            安全管理措置に関する事項
            <p>
              トライアルグループは、匿名加工情報について、漏えい、滅失又はき損の防止等、その管理のために必要かつ適切な安全管理措置を講じます。
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループが作成する匿名加工情報に関する事項
            <p>
              ①トライアルグループは、提供を受けた情報をもとに、匿名加工情報を作成し、第三者に継続的に提供いたします。
            </p>
            <StyledList liWidth="960" marginLeft="2.7" paddingLeft="2">
              <StyledListItem listType="boldArticle">
                個人に関する情報の項目（匿名加工情報に含まれる項目）
                <p>
                  属性情報（性別、年齢区分、来店距離、仮ID（トライアル会員IDを復元出来ないよう置き換えたもの）、家族構成、介護者・非介護者の別、業者・非業者の別、興味関心に関する事項等）及び購入情報（購入日、店舗番号、店舗名、商品名、購入数量、購入金額等）
                </p>
              </StyledListItem>
              <StyledListItem listType="boldArticle">
                提供の方法
                <p>パスワードにより保護されたサーバーにアップロードする方法</p>
              </StyledListItem>
            </StyledList>
            <p>
              ②トライアルグループは、上記①の（1）以外の匿名加工情報を作成した場合、匿名加工情報に含まれる個人に関する情報の項目を公表します。
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            第三者提供をする匿名加工情報に関する事項
            <p>
              トライアルグループは、「（2）トライアルグループが作成する匿名加工情報に関する事項」の場合を除き、匿名加工情報を第三者に提供する場合には、提供しようとする匿名加工情報に含まれる個人に関する情報の項目と提供の方法を公表します。
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            識別行為の禁止
            <p>
              トライアルグループは、匿名加工情報について、当該匿名加工情報の作成に用いられた個人情報に係る本人を識別するため、当該個人情報から削除された記述等や個人識別符号、若しくは加工の方法に関する情報を取得し、当該匿名加工情報を他の情報と照合しないものとします。
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            お問い合わせ及び苦情の窓口
            <p>
              本プライバシーポリシー「第13条（個人情報についてのお問い合わせ窓口）」までご連絡ください。
            </p>
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy6',
  },
  {
    children: (
      <>
        <h3>第7条（Cookieの利用）</h3>
        <p>
          トライアルグループは、お客様等の同意を得てCookieを取得した上で、お客様等の「トライアル会員ID」ほか、閲覧されたトライアルグループのウェブサイト等の閲覧履歴、トライアルグループでのお買い物履歴やサービスご利用履歴等を組み合わせて分析し、お客様等の関心・嗜好にあわせた商品・サービス等のご提案やお知らせのご案内、マーケティング調査、広告配信に役立てています。
        </p>
        <p>
          Cookieとは、ウェブサイトにアクセスしたユーザーに関する情報を保存する仕組みのことです。Cookieの機能を停止（オプトアウト）されたい場合は
          <LinkText path="/cookie-management" text="こちら" />
          から設定してください。
        </p>
      </>
    ),
    id: 'privacy7',
  },
  {
    children: (
      <>
        <h3>
          第8条（お客様等による個人情報の開示、訂正、追加、削除又は利用停止の請求）
        </h3>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            お客様等は、お客様等ご本人様が登録した個人情報について、本プライバシーポリシー「第13条（個人情報についてのお問い合わせ窓口）」を通じて、トライアルグループ所定の方法により、開示、訂正、追加、削除又は利用停止を求めることができます。但し、次のいずれかに該当する場合は、個人情報の全部又は一部について開示できない場合もございますのでご了承ください。
            <br />
            ①開示することでお客様等本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
            <br />
            ②開示することでトライアルグループの業務の適正な実施に著しい支障を及ぼすおそれがある場合
            <br />
            ③開示することが法令に違反することとなる場合
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、お客様等のお申し出による開示請求に迅速にお応えし、その結果万一誤った情報があった場合には速やかに訂正いたします。その場合、個人情報を厳格に管理する立場から、開示請求者ご本人様であることを証明する書類などのご提示をお願いする場合もございますので、ご理解をお願いいたします。また、個人情報の開示に際しては、トライアルグループの所定の開示手数料をお支払いいただく場合があることをご了承ください。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy8',
  },
  {
    children: (
      <>
        <h3>第9条（EU及び英国域内居住者データの取り扱いについて）</h3>
        <p>
          本条の規定は、EU一般データ保護規則及び同規則に相当する英国法（以下「GDPR」と総称します。）に基づき、欧州連合（本条ではアイスランド、リヒテンシュタイン及びノルウェーを含み、以下「ＥＵ」といいます。）及び英国域内に居住する方を識別する又は識別できる情報（以下「EU及び英国域内居住者データ」といい、当該EU及び英国域内居住者データの主体である自然人を「EU及び英国域内居住者データ主体」といいます。）の取り扱いに限り適用されます。本プライバシーポリシーの規定は、「第10条（米国カリフォルニア州居住者の個人情報の取り扱いについて）」を除き、EU及び英国域内居住者データにも適用されます。
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループが収集したEU及び英国域内居住者データ及びその共有先は、以下の通りです。なお、トライアルグループは、EU及び英国域内居住者データの販売はしておりません。
          </StyledListItem>
        </StyledList>
        <GridTable>
          <GridRow>
            <div>EU及び英国域内居住者データのカテゴリーとその例</div>
            <div>情報源のカテゴリー</div>
            <div>事業上又は商業上の利用目的</div>
            <div>EU及び英国域内居住者データを共有する第三者のカテゴリー</div>
          </GridRow>
          <GridRow>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  個人の識別情報（氏名、メールアドレス等）
                </StyledListItem>
                <StyledListItem listType="disc">
                  勤務先・所属先に関する情報（所属会社、法人、所属部署、役職等）
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>EU及び英国域内居住者データ主体本人から直接収集</div>
            <div>情報交換等</div>
            <div>共有しておりません</div>
          </GridRow>
          <GridRow>
            <div>
              インターネット等のネットワーク活動に関する情報（Cookieにより収集された情報。Cookie機能をオプトアウトされたい場合は、
              <LinkText path="/cookie-management" text="こちら" />
              から設定してください）
            </div>
            <div>
              トライアルグループのウェブサイト等を閲覧・ご利用いただくことにより収集
            </div>
            <div>アクセス履歴の確認等</div>
            <div>
              第3条に定める共同利用者範囲
            </div>
          </GridRow>
        </GridTable>
        <StyledList
          liWidth="960"
          marginLeft="0.5"
          paddingLeft="0.5"
          startValue={1}
        >
          <StyledListItem listType="article">
            トライアルグループがGDPRにおける管理者（EU及び英国域内居住者データの取り扱い方法及び目的を決定する者を指します。）としてEU及び英国域内居住者データを取り扱う場合には、トライアルグループは、他に法的根拠が存在する場合を除き、EU及び英国域内居住者データ主体に対して、EU及び英国域内居住者データの取り扱いの目的その他のGDPR上の要告知事項を明示し、EU及び英国域内居住者データ主体から、その取り扱いについての同意を得るものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            前項の同意取得時の説明は、明瞭かつ平易な文言を用い、理解しやすくかつ容易にアクセス出来る形で、その他の案件と明らかに区別できる方法によって明示するものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、EU及び英国域内居住者データ主体から得られたEU及び英国域内居住者データの取り扱いに関する同意について、その同意の証明を求められた際に提示できるように記録を保存するものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、（1）の表に記載したEU及び英国域内居住者データを、同表の「事業上又は商業上の利用目的」のために必要がある限り、保持するものとします。法令や会計上の規定により、必要な期間よりも長期にわたり保持することが求められ、又は認められる場合は、トライアルグループの業務上の必要性等も考慮した上で保持期間を決定するものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            EU及び英国域内居住者データ主体は、構造化され、一般的に利用され、かつ機械で読み取り可能な形式でトライアルグループから自身のEU及び英国域内居住者データを受領することができ、また、受領したEU及び英国域内居住者データをトライアルグループに妨げられることなく別の管理者に転送することができます。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループがEU及び英国域内居住者データ主体の同意を得て行うEU及び英国域内居住者データの取り扱いに関し、EU及び英国域内居住者データ主体は、いつでもその同意を撤回する権利を有しています。なお、トライアルグループによるEU及び英国域内居住者データの取り扱いの適法性が、EU及び英国域内居住者データ主体の同意撤回により影響を受けることはありません。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、EU及び英国域内居住者データをEU及び英国以外の国（日本を含みます。）に移転して取り扱う場合があります。日本は、欧州委員会から個人情報の保護が十分になされているとして十分性認定を受けています。日本、EU、英国以外の移転先の国は、EU及び英国域内居住者データ主体が居住している国と同等の個人情報保護法制でない可能性がありますが、トライアルグループはGDPRに基づく標準契約条項をデータ移転先と締結することなどにより、EU及び英国域内居住者データを保護します。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループがGDPRにおける処理者（管理者からの書面による指示に基づき行動する者を指します。）としてEU及び英国域内居住者データを取り扱う場合には、当該EU及び英国域内居住者データの管理者の指示に従い、適切に当該EU及び英国域内居住者データを取り扱うものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループがGDPRにおける管理者として取り扱うEU及び英国域内居住者データに関し、EU及び英国域内居住者データ主体が、GDPRにおいてデータ主体に認められる権利行使等に関わるお問い合わせをされる場合は、本プライバシーポリシー「第13条（個人情報についてのお問い合わせ窓口）」の連絡先に、お申し出ください。なお、お申し出への対応に当たっては、ご本人またはその代理人であることを確認させていただきます。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、トライアルグループがGDPRにおける管理者として取り扱うEU及び英国域内居住者データに関し、GDPRにおいてデータ主体に認められる権利行使等を受けた場合には、GDPRの規定に従って対応するものとします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy9',
  },
  {
    children: (
      <>
        <h3>
          第10条（米国カリフォルニア州居住者の個人情報の取り扱いについて）
        </h3>
        <p>
          本条の規定は、カリフォルニア州消費者プライバシー法（以下「CCPA」といいます。）に基づき、米国カリフォルニア州に居住する方の個人情報（本条においては、特定の消費者又は世帯を、識別し、関連し、叙述し、合理的に関連付けることができ、又は直接的に若しくは間接的に合理的にリンクさせることができる情報をいうものとします。）の取り扱いに限り、適用されます。本プライバシーポリシーの規定は、「第9条（EU及び英国域内居住者データの取り扱いについて）」を除き、米国カリフォルニア州の居住者の個人情報にも適用されます。
        </p>
        <StyledList liWidth="960" marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="boldArticle">
            個人情報の収集・利用
            <p>
              トライアルグループが、米国カリフォルニア州の居住者から過去12か月間に収集した個人情報、その利用目的及び共有先は以下の通りです。なお、トライアルグループは、米国カリフォルニア州の居住者の個人情報（未成年者の個人情報を含みます。）を第三者に販売はしておらず、過去12か月間に販売したこともありません。
            </p>
          </StyledListItem>
        </StyledList>
        <GridTable>
          <GridRow>
            <div>
              米国カリフォルニア州の居住者の個人情報のカテゴリーとその例
            </div>
            <div>情報源のカテゴリー</div>
            <div>事業上又は商業上の利用目的</div>
            <div>
              米国カリフォルニア州の居住者の個人情報を共有する第三者のカテゴリー
            </div>
          </GridRow>
          <GridRow>
            <div>
              <StyledListInGridRow paddingLeft="0.5">
                <StyledListItem listType="disc">
                  個人の識別情報（氏名、メールアドレス等）
                </StyledListItem>
                <StyledListItem listType="disc">
                  勤務先・所属先に関する情報（所属会社、法人、所属部署、役職等）
                </StyledListItem>
              </StyledListInGridRow>
            </div>
            <div>米国カリフォルニア州の居住者本人から直接収集</div>
            <div>情報交換等</div>
            <div>共有しておりません</div>
          </GridRow>
          <GridRow>
            <div>
              インターネット等のネットワーク活動に関する情報（Cookieにより収集された情報。Cookie機能をオプトアウトされたい場合は、
              <LinkText path="/cookie-management" text="こちら" />
              から設定してください）
            </div>
            <div>
              トライアルグループのウェブサイト等を閲覧・ご利用いただくことにより収集
            </div>
            <div>アクセス履歴の確認等</div>
            <div>
              第3条に定める共同利用者範囲
            </div>
          </GridRow>
        </GridTable>
        <StyledList
          liWidth="960"
          marginLeft="0.5"
          paddingLeft="0.5"
          startValue={1}
        >
          <StyledListItem listType="boldArticle">
            米国カリフォルニア州の居住者の権利について
            <br /> ①開示請求権
            <p>
              米国カリフォルニア州の居住者は、過去12か月間にトライアルグループが収集、利用、共有した個人情報について、以下の情報を開示する
              ようトライアルグループに請求する権利があります。
            </p>
            <StyledList marginLeft="1" paddingLeft="0.5">
              <StyledListItem listType="disc">
                収集した個人情報の種類
              </StyledListItem>
              <StyledListItem listType="disc">
                個人情報の収集方法の種類
              </StyledListItem>
              <StyledListItem listType="disc">
                個人情報を収集する際の事業上または商業上の目的
              </StyledListItem>
              <StyledListItem listType="disc">
                事業上の目的のために共有した個人情報の種類
              </StyledListItem>
              <StyledListItem listType="disc">
                個人情報の種類ごとの、共有先である第三者の種類
              </StyledListItem>
              <StyledListItem listType="disc">
                開示請求をされた米国カリフォルニア州の居住者自身に関する具体的な個人情報
              </StyledListItem>
            </StyledList>
            ②削除権
            <p>
              米国カリフォルニア州の居住者は、トライアルグループが取得した一定の個人情報について削除するよう請求する権利を有しています。
            </p>
            ③差別的取り扱いの禁止に関する権利
            <p>
              トライアルグループは、米国カリフォルニア州の居住者がCCPAに基づく権利を行使したことを理由に、当該居住者を差別的に取り扱うことはありません。しかし、個人情報の削除により、従来ご利用可能だったサービスの提供ができなくなる場合があります。あらかじめ、ご了承ください。
            </p>
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            米国カリフォルニア州の居住者がCCPAに基づく権利行使等に関わるお問い合わせをされる場合は、本プライバシーポリシー「第13条（個人情報についてのお問い合わせ窓口）」の連絡先に、お申し出ください。なお、お申し出への対応に当たっては、ご本人またはその代理人であることを確認させていただきます。
          </StyledListItem>
          <StyledListItem listType="boldArticle">
            トライアルグループは、米国カリフォルニア州の居住者からCCPAに基づく権利行使等を受けた場合には、CCPAの規定に従って対応するものとします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'privacy10',
  },
  {
    children: (
      <>
        <h3>第11条（第三者の企業のリンク先に関する免責）</h3>
        <p>
          このウェブサイト上にリンク先があるトライアルグループではない第三者の企業に関する事項ついては、トライアルグループの責任範囲外となります。かかる事項については、当該企業が設定する規約及びプライバシーポリシーに準拠することとなります。
        </p>
      </>
    ),
    id: 'privacy11',
  },
  {
    children: (
      <>
        <h3>第12条（本プライバシーポリシーの改定）</h3>
        <p>
          トライアルグループは、個人情報保護法等を遵守するため、本プライバシーポリシーを適宜変更又は改定する場合があります。本プライバシーポリシーを変更又は改定する場合は、その内容をこのウェブサイト上に掲載しますので、お客様等においては、変更又は改定後の本プライバシーポリシーを十分にご確認ください。
        </p>
      </>
    ),
    id: 'privacy12',
  },
  {
    children: (
      <>
        <h3>第13条（個人情報についてのお問い合わせ窓口）</h3>
        <p>
          本プライバシーポリシーに関してご不明な点がある場合、トライアルグループにおける個人情報の取り扱いに関するご質問・ご相談がある場合は、以下のお問い合わせ窓口までご連絡ください。
        </p>
      </>
    ),
    id: 'privacy13',
  },
  {
    children: (
      <>
        <p>
          <span>
            株式会社トライアルカンパニー
            <ZenkakuSpace />
            お客様相談室（受付時間：9:00〜22:00。）
          </span>
          <br />
          TEL : 0120-033-559
          <br />
          インターネットのお問い合わせフォームは
          <LinkText path="/contact/" text="こちら" />
          です。
          <br />
          <br />
          <span>【西友についてはこちら】(受付時間：9:00〜22:00。但し年始を除く）</span>
          <br />
          <span>西友お客様相談窓口</span>
          <br />
          TEL : 0120-360-373
          <br />
          インターネットのお問い合わせフォームは<a href="https://www.seiyu.co.jp/contact/" target="_blank" rel="noreferrer">こちら</a>です。
          <br />
          <br />
          <span>SEIYUドットコムギフト館カスタマーセンター</span>
          <br />
          （SEIYUドットコムギフト館のご利用に関するお問い合わせ）
          <br />
          インターネットのお問い合わせフォームは<a href="https://gift.the-seiyu.com/ec/guestInquiryEdit.html" target="_blank" rel="noreferrer">こちら</a>です。
          <br />
          <br />
          制定日
          <ZenkakuSpace />
          2022年12月26日
          <br />
          最終改定日
          <ZenkakuSpace />
          2026年02月16日
        </p>
      </>
    ),
    id: 'privacy14',
  },
]

export const pvLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（個人情報の収集と管理）',
      anchor: 'privacy1',
    },
    {
      name: '（利用目的）',
      anchor: 'privacy2',
    },
    {
      name: '（個人情報の共同利用）',
      anchor: 'privacy3',
    },
    {
      name: '（第三者への提供）',
      anchor: 'privacy4',
    },
    {
      name: '（外国にある第三者への提供）',
      anchor: 'privacy5',
    },
    {
      name: '（匿名加工情報の活用）',
      anchor: 'privacy6',
    },
    {
      name: '（Cookieの利用）',
      anchor: 'privacy7',
    },
  ],
  [
    {
      name: '（お客様等による個人情報の開示、訂正、追加、削除又は利用停止の請求）',
      anchor: 'privacy8',
    },
    {
      name: '（EU及び英国域内居住者データの取り扱いについて）',
      anchor: 'privacy9',
    },
    {
      name: '（米国カリフォルニア州居住者の個人情報の取り扱いについて）',
      anchor: 'privacy10',
    },
    {
      name: '（第三者の企業のリンク先に関する免責）',
      anchor: 'privacy11',
    },
    {
      name: '（本プライバシーポリシーの改定）',
      anchor: 'privacy12',
    },
    {
      name: '（個人情報についてのお問い合わせ窓口）',
      anchor: 'privacy13',
    },
  ],
]

//  外部送信ポリシー(External transmission)

export const etItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. はじめに</h3>
        <p>
          トライアルグループが運営するスマートフォンアプリである「TRIAL＋」、「SU-PAY」（「SU-PAY」に付随して提供されるサービスを含みます。以下、これらを総称して「本サービス」といいます。）、および「３．外部送信について」に記載されたサイトでは、利用状況の把握、利便性向上や統計データ分析並びに広告の配信、表示及び効果測定等の目的で、クッキー（Cookie）及びこれに類似する技術を利用し、利用者の端末から利用者以外の者のサーバーに利用者に関する情報を送信（以下「外部送信」といいます。）することがあります。
        </p>
        <p>
          トライアルグループは、本サービスを提供するにあたって、外部の事業者のサービス（以下「外部サービス」といいます。）を利用することで、外部サービスの利用において必要となる利用者に関する情報（Cookieに保存された利用者の識別子、端末のOS情報等。以下「利用者情報」といいます。）を、プライバシーを尊重した上で、当該外部サービスを提供する事業者に外部送信しております。
          <br />
          ※Cookieとは、利用者が本サービスにアクセスした際に、ご利用の端末のブラウザを通じて端末上に保存されるテキストデータです。
        </p>
      </>
    ),
    id: 'privacy1',
  },

  {
    children: (
      <>
        <h3>2. オプトアウト措置（外部送信の停止等）について</h3>
        <p>
          お客様等は、ブラウザの設定等により、お客様等の判断で外部送信の停止等を行うことができる場合があります。このような選択をした場合、本サービスを正常にご利用いただけなくなる可能性がありますので、あらかじめご了承ください。
        </p>
      </>
    ),
    id: 'privacy2',
  },

  {
    children: (
      <>
        <h3>3. 外部送信について</h3>
        <p>
          現在トライアルグループが外部送信のために利用している外部サービスに関し、電気通信事業法の外部送信規律に関する規定（電気通信事業法第27条の12）又は送信先となる外部事業者の要請等に基づき公表する事項は、以下のとおりです。送信される利用者情報の送信先での利用目的については、「送信先のプライバシーポリシー等」記載のリンク先をご確認ください。
        </p>

        <div style={{ width: '100%', overflow: 'auto' }}>
          <GridTable2 style={{ minWidth: '1000px' }}>
            <GridRow>
              <div>対象のウェブサイト等</div>
              <div>送信先の事業者／サービス名</div>
              <div>送信される情報の内容</div>
              <div>送信される情報の当社における利用目的 </div>
              <div>送信先のプライバシーポリシー等</div>
              <div>外部送信の停止等の設定</div>
            </GridRow>
            <GridRow>
              <div>
                <a
                  href="https://trial-holdings.inc/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://trial-holdings.inc/
                </a>
                <br />
                <a
                  href="https://www.trial-net.co.jp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.trial-net.co.jp/
                </a>
              </div>
              <div>株式会社プレイド/KARTE</div>
              <div>
                <StyledListInGridRow paddingLeft="0.5">
                  <StyledListItem listType="disc">
                    サイト内のページの閲覧履歴
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    各ページの滞在時間
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    ブラウザやOSの種類/バージョン
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    画面サイズ
                    <br />
                    リファラー
                  </StyledListItem>
                  <StyledListItem listType="disc">アクセス元</StyledListItem>
                  <StyledListItem listType="disc">
                    フォーム送信時のコンバージョンデータ
                  </StyledListItem>
                </StyledListInGridRow>
              </div>
              <div>広告、マーケティング、利用状況分析</div>
              <div>
                <a
                  href="https://karte.io/karte-policy.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://karte.io/karte-policy.html
                </a>
              </div>
              <div>
                <a
                  href="https://karte.io/optout/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://karte.io/optout/
                </a>
              </div>
            </GridRow>
            <GridRow>
              <div>
                <a
                  href="https://trial-holdings.inc/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://trial-holdings.inc/
                </a>
                <br />
                <a
                  href="https://www.trial-net.co.jp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.trial-net.co.jp/
                </a>
              </div>
              <div>Google LLC/Firebase</div>
              <div>
                取得情報の内容:{' '}
                <a
                  href="https://policies.google.com/technologies/partner-sites"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://policies.google.com/technologies/partner-sites
                </a>
              </div>
              <div>アクセス解析 </div>
              <div>
                <a
                  href="https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://firebase.google.com/support/privacy?hl=ja#firebase_data_processing_and_security_terms
                </a>
              </div>
              <div>
                <a
                  href="https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://support.google.com/firebase/answer/9019185?hl=ja#zippy=%2C%E3%81%93%E3%81%AE%E8%A8%98%E4%BA%8B%E3%81%AE%E5%86%85%E5%AE%B98248?hl=ja
                </a>
              </div>
            </GridRow>
            <GridRow>
              <div>
                <a
                  href="https://trial-holdings.inc/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://trial-holdings.inc/
                </a>
                <br />
                <a
                  href="https://www.trial-net.co.jp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.trial-net.co.jp/
                </a>
              </div>
              <div>
                株式会社インティメート・マージャー/インティメート・マージャー
              </div>
              <div>
                <StyledListInGridRow paddingLeft="0.5">
                  <StyledListItem listType="disc">
                    クッキーに保存されたユニークID
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    サイトへの訪問日時もしくは広告接触日時
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    訪問したサイトのURL
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    訪問したサイトのタイトルやメタキーワード
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    訪問時のリファラ
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    アクセス元のIPアドレス
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    ブラウザのユーザーエージェント
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    ブラウザの言語設定と文字エンコーディング設定
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    ブラウザの表示領域と色深度
                  </StyledListItem>
                </StyledListInGridRow>
              </div>
              <div>位置情報に応じたコンテンツの配信、利用状況把握によるマーケティング情報の取得・サービス改善等</div>
              <div>
                <a
                  href="https://corp.intimatemerger.com/privacypolicy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://corp.intimatemerger.com/privacypolicy/
                </a>
              </div>
              <div>
                <a
                  href="https://corp.intimatemerger.com/privacypolicy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://corp.intimatemerger.com/privacypolicy/
                </a>
              </div>
            </GridRow>
            <GridRow>
              <div>
                SU-PAY
                <br />
                TRIAL＋
              </div>
              <div>株式会社unerry</div>
              <div>
                <StyledListInGridRow paddingLeft="0.5">
                  <StyledListItem listType="disc">
                    スマートフォン等の端末情報（端末機種名、端末メーカー、端末OSバージョンおよび使用言語情報。）
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    広告識別子（IDFAまたはGoogle Advertising ID等。）
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    スマートフォン等にかかる位置情報
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    アプリユーザーの取得した近傍のビーコンにかかる情報
                  </StyledListItem>
                  <StyledListItem listType="disc">IPアドレス</StyledListItem>
                  <StyledListItem listType="disc">
                    本アプリの利用状況にかかる情報（位置情報利用許可の有無、Bluetoothのオン/オフ、プッシュコンテンツの閲覧・開封日時、反応したビーコンの情報を含む。）
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    本アプリの提供者が必要と判断したアプリユーザーのセグメント情報（年代、性別、職業など。ただし、個人情報を除く。）
                    <br /> ※詳細については
                    <a
                      href="https://su-pay.jp/terms/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://su-pay.jp/terms/
                    </a>
                    をご覧ください。
                  </StyledListItem>
                </StyledListInGridRow>
              </div>
              <div>
                位置情報に応じたコンテンツの配信、利用状況把握によるマーケティング情報の取得・サービス改善等{' '}
              </div>
              <div>
                <a
                  href="https://www.unerry.co.jp/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.unerry.co.jp/privacy/
                </a>
              </div>
              <div>
                <a
                  href="https://www.unerry.co.jp/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.unerry.co.jp/privacy/
                </a>
              </div>
            </GridRow>
            <GridRow>
              <div>
                <a
                  href="https://miyawaka-toranoyu.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://miyawaka-toranoyu.com/
                </a>
                <br />
                <a
                  href="https://kominka-neri.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://kominka-neri.com/
                </a>
                <br />
                <a
                  href="https://toranoyu.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://toranoyu.com/
                </a>
                <br />
                <a
                  href="https://www.kuoritei.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.kuoritei.com/
                </a>
                <br />
                <a
                  href="https://www.sengokuharatoranoyu.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.sengokuharatoranoyu.com/
                </a>
                <br />
                <a
                  href="https://hakonekuoritei.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://hakonekuoritei.com/
                </a>
              </div>
              <div>Microsoft Corporation/ Clarity</div>
              <div>
                (1)左記ウェブサイトの閲覧履歴（閲覧した日時、URL、カテゴリー分類、リンク元のURL等）<br/>
                (2)左記ウェブサイトを閲覧した機器の位置情報（IPアドレス、GPS情報等）<br/>
                (3)利用者やその機器を識別する情報（ユーザーID、ブラウザ識別子、デバイス識別子等）
              </div>
              <div>
                ウェブサイトの閲覧状況分析
              </div>
              <div>
                <a
                  href="https://privacy.microsoft.com/ja-jp/privacystatement"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://privacy.microsoft.com/ja-jp/privacystatement
                </a>
              </div>
              <div>
                ―
              </div>
            </GridRow>
          </GridTable2>
        </div>
        <p>
          なお、トライアルグループは、上記一覧に表示する外部送信のほか、本サービスの提供にあたり必要な情報（例えば、入力した情報の保持等に必要な情報、ユーザー認証に必要な情報、不正アクセスの検知や防止等のセキュリティ対策のために必要な情報、障害やエラーの検知や対策等のネットワーク管理に必要な情報等を含みますが、これに限りません。）について、外部送信しております。
        </p>
        <p>
          制定日:2023年09月05日
        <br/>
          最終改定日:2026年02月16日
        </p>
      </>
    ),
    id: 'privacy3',
  },
]
